import { createFeatureSelector, createSelector, MemoizedSelector } from "@ngrx/store";
import { PostState } from "./post.state";

export const postSelectors = (entityStateId: string) => {
  const selectPostState = createFeatureSelector<PostState>(entityStateId);
  (selectPostState as any).__isFeatureSelector = true;
  const selectNonNullPostState = createSelector(
    selectPostState as MemoizedSelector<object, any | undefined>,
    (state) => state ?? null
  );

  const selectPostText = createSelector(
    selectNonNullPostState,
    (state: PostState) => state?.text,
  );
  return {
    selectPostState,
    selectPostText
  }
}

